"use client";

import { type ConsumerProps, memo, type NamedExoticComponent } from "react";

/**
 * Creates a named context consumer component by invoking the useContext hook
 * @param name name of the consumer component
 * @param useContext hook to provide the context object
 * @returns context consumer component
 */
export function createNamedConsumer<R>(name: string, useContext: () => R): NamedExoticComponent<ConsumerProps<R>> {
  const Consumer = memo<ConsumerProps<R>>(({ children }) => <>{children(useContext())}</>);
  Consumer.displayName = name;

  return Consumer;
}
